// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:23
import { UserActivity_abstract } from './../abstract/SagaBase/UserActivity_abstract';
export class UserActivity extends UserActivity_abstract {}
